import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2538a225"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "detail"
}
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 1,
  class: "list"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "一覧", -1))
const _hoisted_6 = { class: "info-popup-inner" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "info-popup-inner-index"
}
const _hoisted_9 = { class: "info-items" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]

import { ref, onMounted, computed } from 'vue'
import { usePopup } from '@/components/common/Popup'
import NewsItem from '@/models/NewsItem'
import { useNewsHistoryStore } from '@/stores/newsStore'
import { useGlobalStore } from '@/stores/globalStore'
import { addLinkOnText } from '@/lib/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const MODES = {
  INDEX: 'index',
  DETAIL: 'detail',
} as const
const mode = ref<(typeof MODES)[keyof typeof MODES]>(MODES.DETAIL)
const newsItem = ref<NewsItem | undefined>()
const newsStore = useNewsHistoryStore()
const globalStore = useGlobalStore()
const { open } = usePopup()

onMounted(async () => {
  await newsStore.fetch()

  if (newsStore.newsCurrent.items === undefined) {
    return
  }

  newsItem.value = newsStore.newsCurrent.items[0]

  // 24時間以内のお知らせがある場合に矯正表示
  if (hasTodayNews.value) {
    open()
  }
})

const news = computed(() => {
  return newsStore.newsCurrent
})
const isIndexView = computed(() => {
  return mode.value === MODES.INDEX
})

const isDetailiew = computed(() => {
  return mode.value === MODES.DETAIL
})

const hasTodayNews = computed(() => {
  if (newsItem.value === undefined || newsItem.value.id === undefined) {
    return false
  }

  return newsItem.value.isTodayNews()
})

const handleClickIndex = () => {
  mode.value = MODES.INDEX
}

const handleClickDetail = (id: number) => {
  if (news.value === undefined) {
    return
  }

  newsItem.value = news.value.findById(id)
  mode.value = MODES.DETAIL
}

const handleClickPrev = () => {
  if (news.value === undefined || newsItem.value === undefined || newsItem.value.id === undefined) {
    return
  }

  const item = news.value.prev(newsItem.value.id)

  if (item === undefined) {
    return
  }

  newsItem.value = item
}

const handleClickNext = () => {
  if (news.value === undefined || newsItem.value === undefined || newsItem.value.id === undefined) {
    return
  }

  const item = news.value.next(newsItem.value.id)

  if (item === undefined) {
    return
  }

  newsItem.value = item
}

const handleClickNew = () => {
  if (news.value === undefined) {
    return
  }

  newsItem.value = news.value.items[0]
  mode.value = MODES.DETAIL
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (newsItem.value)
    ? (_openBlock(), _createBlock(_component_Popup, { key: 0 }, {
        header: _withCtx(() => [
          (_unref(isDetailiew))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(newsItem.value.formatTime()), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(newsItem.value.title), 1),
                _createElementVNode("div", { class: "controls" }, [
                  _createElementVNode("button", {
                    onClick: handleClickPrev,
                    class: "btn btn-prev"
                  }),
                  _createElementVNode("span", {
                    onClick: handleClickIndex,
                    class: "view-history"
                  }, "一覧"),
                  _createElementVNode("button", {
                    onClick: handleClickNext,
                    class: "btn btn-next"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isIndexView))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", { class: "controls" }, [
                  _createElementVNode("span", {
                    onClick: handleClickNew,
                    class: "view-history view-recent"
                  }, "最新")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_unref(isDetailiew))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _unref(addLinkOnText)(newsItem.value.description),
                  class: "info-popup-inner-detail"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_unref(isIndexView))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news)?.items, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "info-items-item"
                      }, [
                        _createElementVNode("span", _hoisted_10, [
                          _createTextVNode("●" + _toDisplayString(item.formatTime()), 1),
                          (_unref(globalStore).isSP)
                            ? (_openBlock(), _createElementBlock("br", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.title), 1)
                        ]),
                        _createElementVNode("span", {
                          onClick: ($event: any) => (handleClickDetail(item.id as number)),
                          class: "btn btn-detail"
                        }, "詳細", 8, _hoisted_12)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})